export const getSbtPayUrl = (payUrl) => {
    return payUrl + '?pstype=sbp_tochka';
};

export const getCardPayUrl = (payUrl) => {
    return payUrl + '?pstype=tochka';
};
